// extracted by mini-css-extract-plugin
export default {"root":"_1JTINM45","content":"tmuRH_jv","overlay":"_1lhYpV-D","prompt":"LZLoelqH","box":"_2wImQsXV","footer":"_3gWPk2pM"};